export default "__VITE_ASSET__7a5932c8__"